import React, { SVGProps } from 'react';

const SvgShareOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={props.color || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.2 2.6 21.8 12l-8.6 9.4V14.8c-6.3 0-8.4 4.3-10.9 5.8 0-6.41 4.88-11.6 10.9-11.6Z"
    />
  </svg>
);
SvgShareOutlineIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgShareOutlineIcon;
